import styles from "./Spinner.module.css"; // Assuming you have a CSS module for styles

function Spinner() {
  return (
    <div className={styles.spinnerWrapper}>
      <div className={styles.spinner}></div>
    </div>
  );
}

export default Spinner;
